const urlParameter = (nameParam: string) => {
  nameParam = nameParam.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + nameParam + '=([^&#]*)'),
    results = regex.exec(window.location.search);
  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export default urlParameter;
